export const formatDampingRatio = (value) => {
  if (value === null || value === undefined || value === '') {
    return '--';
  }

  const ratio = Number(value);
  if (!Number.isFinite(ratio) || ratio < 0) {
    return '--';
  }

  const percentage = (ratio * 100).toFixed(3).replace(/\.?0+$/, '');
  return `${percentage}%`;
};

const DampingRatioCell = ({ value }) => {
  const displayValue = formatDampingRatio(value);

  return (
    <td style={{ color: displayValue === '--' ? '#999' : '' }}>
      {displayValue}
    </td>
  );
};

export default DampingRatioCell;
